define("shared/components/shared/ember-drop-multi-select-item", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Ui::Button
    @class={{concat-classes
      "o--dropBody__link u--ellipsis"
      (if this.isSelected "is--active")
      (if this.isNotInSearch "u--hide")
    }}
    @onClick={{fn @handleClick @option this.isSelected @closeEmberDrop}}
    @variant="unstyled"
  >
    {{#if @option.icon}}
      {{svg-jar @option.icon class="o--icon u--m__r__xs"}}
    {{/if}}
    <span>
      {{@option.name}}
      {{svg-jar "check" class="o--icon o--dropBody__listIcon--right"}}
    </span>
  </Shared::Ui::Button>
  */
  {
    "id": "gHx30c/V",
    "block": "[[[8,[39,0],null,[[\"@class\",\"@onClick\",\"@variant\"],[[28,[37,1],[\"o--dropBody__link u--ellipsis\",[52,[30,0,[\"isSelected\"]],\"is--active\"],[52,[30,0,[\"isNotInSearch\"]],\"u--hide\"]],null],[28,[37,3],[[30,1],[30,2],[30,0,[\"isSelected\"]],[30,3]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,2,[\"icon\"]],[[[1,\"    \"],[1,[28,[35,4],[[30,2,[\"icon\"]]],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,1],[12],[1,\"\\n    \"],[1,[30,2,[\"name\"]]],[1,\"\\n    \"],[1,[28,[35,4],[\"check\"],[[\"class\"],[\"o--icon o--dropBody__listIcon--right\"]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]]],[\"@handleClick\",\"@option\",\"@closeEmberDrop\"],false,[\"shared/ui/button\",\"concat-classes\",\"if\",\"fn\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ember-drop-multi-select-item.hbs",
    "isStrictMode": false
  });
  class EmberDropMultiSelectItemComponent extends _component2.default {
    get isSelected() {
      return this.args.selectedOptions?.includes(this.args.option.name);
    }
    get isNotInSearch() {
      return this.args.hasSearchTerm && !this.args.searchedOptions?.includes(this.args.option.name);
    }
  }
  _exports.default = EmberDropMultiSelectItemComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EmberDropMultiSelectItemComponent);
});